export async function generateBybitSignature(params: any, apiSecret: string): Promise<string> {
  try {
    const timestamp = Date.now().toString();
    const recvWindow = '5000';

    // Create signature payload: timestamp + apiKey + recvWindow + params
    const queryString = Object.keys(params)
      .sort()
      .map(key => `${key}=${params[key]}`)
      .join('&');

    const signaturePayload = `${timestamp}${recvWindow}${queryString}`;
    
    // Generate HMAC SHA256 signature using Web Crypto API
    const encoder = new TextEncoder();
    const key = await crypto.subtle.importKey(
      'raw',
      encoder.encode(apiSecret),
      { name: 'HMAC', hash: 'SHA-256' },
      false,
      ['sign']
    );
    
    const signature = await crypto.subtle.sign(
      'HMAC',
      key,
      encoder.encode(signaturePayload)
    );

    // Convert to hex
    return Array.from(new Uint8Array(signature))
      .map(b => b.toString(16).padStart(2, '0'))
      .join('');
  } catch (error) {
    console.error('Failed to generate signature:', error);
    throw new Error('Failed to generate signature');
  }
}
